export const REACT_APP_SERVER_URL =
  process.env.REACT_APP_SERVER_URL || 'https://local.derp.website:8107';

// Hack to hide images that do not look good with a white background
export const HIDE_HEADER_IMG_SLUGS = ['cleveland--oh', 'lisbon-portugal'];
